/* KidResq theme — theme.js (vanilla, no dependencies) */
(() => {
  'use strict';

  const KR = window.KR || { routes: { root: '/' }, strings: {} };
  const root = (KR.routes.root || '/').replace(/\/$/, '');
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* storage blocked */ } }
  };

  /* ---------------- Announcement rotator ---------------- */
  function initAnnouncement() {
    const bar = $('[data-announce]');
    if (!bar) return;
    const msgs = $$('.announce__msg', bar);
    if (msgs.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4000);
  }

  /* ---------------- Mobile nav ---------------- */
  function initMobileNav() {
    const nav = $('[data-mnav]');
    if (!nav) return;
    const close = () => { nav.removeAttribute('open'); document.body.style.overflow = ''; };
    nav.addEventListener('toggle', () => { document.body.style.overflow = nav.open ? 'hidden' : ''; });
    $$('[data-mnav-close]', nav).forEach(b => b.addEventListener('click', close));
    $$('.mnav__link', nav).forEach(a => a.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && nav.open) close(); });
  }

  /* ---------------- Localization auto-submit ---------------- */
  function initLocalization() {
    $$('[data-loc-auto]').forEach(sel => sel.addEventListener('change', () => sel.form.submit()));
  }

  /* ---------------- Region banner (UAE <-> KSA store) ---------------- */
  function initRegionBanner() {
    const banner = $('[data-region-banner]');
    if (!banner || store.get('kr-region-dismissed')) return;
    const altRegion = banner.dataset.altRegion;
    fetch(root + '/browsing_context_suggestions.json?country[enabled]=true')
      .then(r => r.json())
      .then(d => {
        const c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (c && c.toUpperCase() === altRegion) banner.hidden = false;
      })
      .catch(() => {});
    const x = $('[data-region-close]', banner);
    if (x) x.addEventListener('click', () => { banner.hidden = true; store.set('kr-region-dismissed', '1'); });
  }

  /* ---------------- Delivery estimate (skips local weekend) ---------------- */
  function addWorkingDays(date, n, weekend) {
    const d = new Date(date);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (!weekend.includes(d.getDay())) added++;
    }
    return d;
  }
  function initDelivery() {
    const els = $$('[data-delivery-eta]');
    if (!els.length || !KR.strings.deliveryRange) return;
    // UAE weekend: Sat-Sun (6,0). KSA weekend: Fri-Sat (5,6).
    const weekend = KR.region === 'SA' ? [5, 6] : [6, 0];
    const now = new Date();
    const from = addWorkingDays(now, KR.delivery.min || 2, weekend);
    const to = addWorkingDays(now, KR.delivery.max || 3, weekend);
    let fmt;
    try {
      fmt = new Intl.DateTimeFormat(KR.locale === 'ar' ? 'ar-AE' : 'en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (e) { return; }
    const text = KR.strings.deliveryRange.replace('__FROM__', fmt.format(from)).replace('__TO__', fmt.format(to));
    els.forEach(el => { el.textContent = text; });
  }

  /* ---------------- Lazy autoplay videos ---------------- */
  function initVideos() {
    const vids = $$('[data-lazy-video]');
    if (!vids.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const load = v => {
      if (v.dataset.loaded) return;
      $$('source[data-src]', v).forEach(s => { s.src = s.dataset.src; });
      v.load();
      v.dataset.loaded = '1';
    };
    if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => {
        const v = en.target;
        if (en.isIntersecting) {
          load(v);
          if (!reduce && !v.hasAttribute('controls')) v.play().catch(() => {});
        } else if (!v.paused && v.muted) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.25 });
    vids.forEach(v => io.observe(v));

    $$('[data-video-sound]').forEach(btn => {
      btn.addEventListener('click', () => {
        const v = btn.parentElement.querySelector('video');
        if (!v) return;
        load(v);
        v.muted = false;
        v.controls = true;
        v.currentTime = 0;
        v.play().catch(() => {});
        btn.classList.add('is-on');
      });
    });
  }

  /* ---------------- Horizontal scrollers (keyboard friendly) ---------------- */
  function initScrollers() {
    $$('[data-scroller]').forEach(s => s.setAttribute('tabindex', '0'));
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery(scope = document) {
    $$('[data-gallery]', scope).forEach(g => {
      const track = $('[data-gallery-track]', g);
      const slides = $$('.gallery__slide', g);
      const dots = $$('.gallery__dot', g);
      const thumbs = $$('[data-thumb]', g);
      if (!track || slides.length < 2) return;
      const setActive = idx => {
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
      };
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const w = track.clientWidth || 1;
          const idx = Math.round(Math.abs(track.scrollLeft) / w);
          setActive(Math.min(idx, slides.length - 1));
        });
      }, { passive: true });
      const goTo = id => {
        const i = slides.findIndex(s => s.dataset.mediaId === String(id));
        if (i < 0) return;
        const dir = document.documentElement.dir === 'rtl' ? -1 : 1;
        track.scrollTo({ left: dir * i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      };
      thumbs.forEach(t => t.addEventListener('click', () => goTo(t.dataset.thumb)));
      g.goTo = goTo;
    });
  }

  /* ---------------- Pack selector ---------------- */
  function syncPack(form) {
    const checked = $('.pack__input:checked', form);
    $$('.pack', form).forEach(p => p.classList.toggle('is-checked', !!$('.pack__input:checked', p)));
    if (!checked) return;
    const d = checked.dataset;
    const priceNow = $('[data-price-now]', form);
    if (priceNow) priceNow.textContent = d.price;
    const was = $('[data-price-was]', form);
    if (was) { if (d.compare) { was.hidden = false; was.lastChild.textContent = d.compare; } else { was.hidden = true; } }
    const save = $('[data-price-save]', form);
    if (save) { if (d.save) { save.hidden = false; $('[data-price-save-amount]', save).textContent = d.save; } else { save.hidden = true; } }
    const inst = $('[data-bnpl-amount]', form);
    if (inst) inst.textContent = d.instal;
    return checked;
  }
  function initPackForms(scope = document) {
    $$('[data-product-form]', scope).forEach(form => {
      syncPack(form);
      form.addEventListener('change', e => {
        if (!e.target.matches('.pack__input')) return;
        const checked = syncPack(form);
        // Main product page: update URL, sticky price and gallery image
        if (form.closest('[data-main-buy]') && checked) {
          const section = form.closest('[data-product-section]');
          const sp = section && $('[data-sticky-price]', section);
          if (sp) sp.textContent = checked.dataset.price;
          if (checked.dataset.variantUrl && window.history.replaceState) {
            window.history.replaceState({}, '', checked.dataset.variantUrl);
          }
          const g = section && $('[data-gallery]', section);
          if (g && g.goTo && checked.dataset.mediaId) g.goTo(checked.dataset.mediaId);
        }
      });
      form.addEventListener('submit', e => {
        const submitter = e.submitter;
        // "Buy now" posts normally with return_to=/checkout (fastest path to payment)
        if (submitter && submitter.name === 'return_to') return;
        e.preventDefault();
        addToCart(form, submitter);
      });
    });
  }

  /* ---------------- Cart (AJAX + section rendering) ---------------- */
  const drawer = () => $('[data-cart-drawer]');
  let lastFocus = null;

  function openDrawer() {
    const d = drawer();
    if (!d) { window.location.href = KR.routes.cart; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const panel = $('.drawer__panel', d);
    setTimeout(() => panel && panel.focus(), 50);
  }
  function closeDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function renderDrawer(html) {
    const d = drawer();
    if (!d || !html) return;
    const tmp = new DOMParser().parseFromString(html, 'text/html');
    const fresh = tmp.querySelector('[data-cart-drawer]');
    if (!fresh) return;
    const panel = $('.drawer__panel', d);
    const freshPanel = $('.drawer__panel', fresh);
    if (panel && freshPanel) panel.innerHTML = freshPanel.innerHTML;
    const count = (fresh.querySelector('[data-cart-items]') || {}).dataset;
    updateCount(count ? Number(count.count) : null);
  }
  function updateCount(n) {
    if (n === null || isNaN(n)) return;
    $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = n === 0; });
  }
  function fetchSections() {
    return fetch(root + '/?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(s => renderDrawer(s['cart-drawer']));
  }
  function setLoading(on) { const d = drawer(); if (d) d.classList.toggle('is-loading', on); }

  function addToCart(form, button) {
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    if (button) button.setAttribute('aria-busy', 'true');
    fetch(KR.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(r => r.json())
      .then(res => {
        if (res.status && res.status !== 200) throw new Error(res.description || KR.strings.error);
        if (res.sections && res.sections['cart-drawer']) renderDrawer(res.sections['cart-drawer']);
        else return fetchSections();
      })
      .then(openDrawer)
      .catch(err => { alertInline(form, err.message || KR.strings.error); })
      .finally(() => { if (button) button.removeAttribute('aria-busy'); });
  }
  function alertInline(form, msg) {
    let el = $('.pform__error', form);
    if (!el) { el = document.createElement('p'); el.className = 'note note--warn pform__error'; el.setAttribute('role', 'alert'); form.appendChild(el); }
    el.textContent = msg;
  }
  function changeLine(key, qty) {
    setLoading(true);
    return fetch(KR.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(r => r.json())
      .then(res => { if (res.sections && res.sections['cart-drawer']) renderDrawer(res.sections['cart-drawer']); else return fetchSections(); })
      .finally(() => setLoading(false));
  }
  function upgrade(btn) {
    const from = btn.dataset.from, to = btn.dataset.to, qty = Number(btn.dataset.qty || 1);
    setLoading(true);
    fetch(KR.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: from, quantity: 0 }) })
      .then(() => fetch(KR.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(to), quantity: qty }], sections: 'cart-drawer', sections_url: window.location.pathname }) }))
      .then(r => r.json())
      .then(res => { if (res.sections && res.sections['cart-drawer']) renderDrawer(res.sections['cart-drawer']); else return fetchSections(); })
      .finally(() => setLoading(false));
  }

  function initCart() {
    document.addEventListener('click', e => {
      const open = e.target.closest('[data-cart-open]');
      if (open && drawer()) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
      const q = e.target.closest('[data-qty-change]');
      if (q) {
        const line = q.closest('[data-line-key]');
        if (line) changeLine(line.dataset.lineKey, Number(q.dataset.qtyChange));
        return;
      }
      const up = e.target.closest('[data-upgrade]');
      if (up) upgrade(up);
    });
    document.addEventListener('keydown', e => {
      const d = drawer();
      if (!d || !d.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeDrawer();
      if (e.key === 'Tab') {
        const f = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', $('.drawer__panel', d)).filter(x => x.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------------- Sticky add to cart (mobile) ---------------- */
  function initStickyATC() {
    const bar = $('[data-sticky-atc]');
    const target = $('[data-main-buy] [data-buy-buttons]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting; // visible whenever the main buy buttons are off-screen (above or below)
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('button', bar).forEach(b => b.tabIndex = show ? 0 : -1);
      document.body.classList.toggle('has-sticky-atc', show);
    });
    io.observe(target);
  }

  /* ---------------- Print button ---------------- */
  function initPrint() {
    $$('[data-print]').forEach(b => b.addEventListener('click', () => window.print()));
  }

  /* ---------------- Theme editor support ---------------- */
  document.addEventListener('shopify:section:load', e => {
    initGallery(e.target); initPackForms(e.target); initVideos(); initDelivery(); initScrollers();
  });

  const init = () => {
    initAnnouncement(); initMobileNav(); initLocalization(); initRegionBanner(); initDelivery();
    initVideos(); initScrollers(); initGallery(); initPackForms(); initCart(); initStickyATC(); initPrint();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
